module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hraRe"))).then(() => parcelRequire('aB3cV'));